import { MaintenanceAspectItemComponentBase } from './maintenance-aspect-item.component.base';
import { Component, ElementRef, Injector, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, positiveIntegerValidator, requiredIfValidator, requiredValidator, UserStorage } from '@scisys-uim/uim-common';
import { Asset } from 'assets-model';
import { MaintenanceAspectService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-maintenance-aspect-item',
  templateUrl: './maintenance-aspect-item.component.html',
  styleUrls: ['./maintenance-aspect-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class MaintenanceAspectItemComponent extends MaintenanceAspectItemComponentBase {

  @Input()
  asset: Asset;

  constructor(protected maintenanceAspectService: MaintenanceAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(maintenanceAspectService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.maintenanceTypeLoadSelectionList();
  }

  createForm(): FormGroup {
    return this.fb.group({
      maintenanceType: [null, [requiredValidator]],
      periodicMaintenance: [null],
      periodicMaintenanceDays: [null, [positiveIntegerValidator]],
      routineMaintenance: [null],
      routineMaintenanceDays: [null, [positiveIntegerValidator]],
      visualInspection: [null],
      latestRoutineMaintenanceDate: [null],
      nextRoutineMaintenanceRequiredDate: [null],
    }, {
      validators: [
        requiredIfValidator(() => this.routineMaintenanceDays, () => this.item.routineMaintenance, "Routine Maintenance Days", { required: "Routine Maintenance Days is required." }),
      ]
    });
  }

  itemSet() {
    super.itemSet();
  }

  setDefaultDisabledFields(): void {
    super.setDefaultDisabledFields();

    this.periodicMaintenanceDays?.disable();
    if (this.item.periodicMaintenance) {
      this.periodicMaintenanceDays?.enable();
    }

    this.routineMaintenanceDays?.disable();
    if (this.item.routineMaintenance) {
      this.routineMaintenanceDays?.enable();
    }
  }

  periodicMaintenanceChangedByUser(value: boolean, unsetDependents?: boolean): void {
    super.periodicMaintenanceChangedByUser(value, unsetDependents);
    if (value) {
      this.periodicMaintenanceDays.enable();
    } else {
      this.periodicMaintenanceDays.disable();
      this.item.periodicMaintenanceDays = null;
    }
  }

  routineMaintenanceChangedByUser(value: boolean, unsetDependents?: boolean): void {
    super.routineMaintenanceChangedByUser(value, unsetDependents);
    if (value) {
      this.routineMaintenanceDays.enable();
    } else {
      this.routineMaintenanceDays.disable();
      this.item.routineMaintenanceDays = null;
    }
  }

}





